import { render, staticRenderFns } from "./StudyConversationMessageActions.vue?vue&type=template&id=0bbb4c28&scoped=true"
import script from "./StudyConversationMessageActions.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageActions.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageActions.vue?vue&type=style&index=0&id=0bbb4c28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb4c28",
  null
  
)

export default component.exports